import { IMovement } from '@/common/integrations/menhir/employee/movements/movements.types';
import { IOperationItem } from '@/common/integrations/menhir/employee/operations/operations.types';
import { EmptyTransactionsPlaceholder } from './components/EmptyTransactionsPlaceholder/EmptyTransactionsPlaceholder';
import { MovementsTable } from './components/MovementsTable/MovementsTable';
import { OperationsTable } from './components/OperationsTable/OperationsTable';

interface ISharedProps {
  translationPrefix?: 'home';
  onUpdate?: () => void;
}

interface IOperationsProps extends ISharedProps {
  type: 'operations';
  transactions: IOperationItem[];
}

interface IMovementsProps extends ISharedProps {
  type?: 'movements';
  transactions: IMovement[];
}

type IProps = IOperationsProps | IMovementsProps;

export const TransactionList = ({
  type,
  transactions,
  translationPrefix,
}: IProps) => {
  const table =
    type === 'operations' ? (
      <OperationsTable transactions={transactions} />
    ) : (
      <MovementsTable transactions={transactions} />
    );

  return (
    <>
      {transactions.length > 0 ? (
        <div data-test-id="transactions-list">{table}</div>
      ) : (
        <EmptyTransactionsPlaceholder translationPrefix={translationPrefix} />
      )}
    </>
  );
};
